import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'il',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    il: {
      translations: require('./locales/il/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false // React already escapes against XSS; avoids "&quot;" showing literally
  }
});

i18n.languages = ['en', 'il'];

export default i18n;